import Box from 'components/shared/Box'
import SinglePhoto from 'components/shared/Gallery/SinglePhoto'
import IconWithText from 'components/shared/IconWithText'
import Modal from 'components/shared/Modal'
import Text from 'components/shared/Text'
import { FormattedMessage, useIntl } from 'react-intl'

import busPhoto from 'assets/images/transport/busPhoto.jpg'
import busPhotoMobile from 'assets/images/transport/busPhoto_mobile.jpg'

import iconBus from 'assets/icons/bus_blue.svg'
import iconBusSeat from 'assets/icons/busSeat.svg'
import iconMap from 'assets/icons/map_blue.svg'
import List from 'components/shared/List'
import { useResolutions } from 'store/resolutions'
import { TransportModalBody } from './styles'
import { UpsellModalProps } from './types'

const TransportModal = ({ isOpened, closeModal }: UpsellModalProps) => {
    const { formatMessage } = useIntl()
    const { isMobile } = useResolutions()

    return (
        <Modal
            isOpened={isOpened}
            maxWidth={670}
            onClose={closeModal}
            isMobileFullscreen={true}
            hasGlobalHeader
            headerMessage={
                <FormattedMessage
                    id="upsells.transport.modal_heading"
                    defaultMessage="Transport autokarowy"
                />
            }
            testIdPrefix="transport-box-about"
        >
            <TransportModalBody
                pt={[24, 40]}
                pl={[16, 40]}
                pr={[16, 40]}
                pb={[24, 40]}
                gap={32}
            >
                <SinglePhoto
                    photoPath={!isMobile ? busPhoto : busPhotoMobile}
                    alt="Suntago Bus"
                    isFullWidth
                />
                <Box
                    isFullWidth
                    justify="space-between"
                    direction={['column', 'row']}
                    gap={[22, 28]}
                >
                    <IconWithText
                        icon={iconBusSeat}
                        iconAlt="Bus seat icon"
                        textHighlighted={formatMessage({
                            id: 'upsells.transport.seating_advantage',
                            defaultMessage: 'Gwarantowane miejsca siedzące*',
                        })}
                        fontVariant="bodySmall"
                        gap={12}
                    />
                    <IconWithText
                        icon={iconBus}
                        iconAlt="Bus icon"
                        textHighlighted={formatMessage({
                            id: 'upsells.transport.coaches_advantage',
                            defaultMessage: 'Nowoczesne autokary',
                        })}
                        fontVariant="bodySmall"
                        gap={12}
                    />
                    <IconWithText
                        icon={iconMap}
                        iconAlt="map icon"
                        textHighlighted={formatMessage({
                            id: 'upsells.transport.routes_advantage',
                            defaultMessage: 'Przejazdy z Warszawy i Żyrardowa',
                        })}
                        fontVariant="bodySmall"
                        gap={12}
                    />
                </Box>
                <Box gap={8} direction="column">
                    <Text variant="heading4" mb={8}>
                        <FormattedMessage
                            id="upsells.transport.modal_guidelines_caption"
                            defaultMessage="Pamiętaj!"
                        />
                    </Text>
                    <List gap={8}>
                        <FormattedMessage
                            id="upsells.transport.modal_guidelines_ticket"
                            defaultMessage="Wszyscy pasażerowie muszą posiadać ważny bilet na przejazd."
                        />
                        <FormattedMessage
                            id="upsells.transport.modal_guidelines_punctuality"
                            defaultMessage="Bądź na przystanku najpóźniej 5 minut przed planowanym odjazdem."
                        />
                        <FormattedMessage
                            id="upsells.transport.modal_guidelines_stops"
                            defaultMessage="Autokary nie zatrzymują się na przystankach pośrednich."
                        />
                        <FormattedMessage
                            id="upsells.transport.modal_guidelines_no_cash"
                            defaultMessage="Bilety na przejazd możesz kupić również w autobusie, płacąc kartą lub BLIKiem (kierowca nie przyjmuje gotówki)."
                        />
                    </List>
                    <Text
                        variant="bodySmall"
                        color="grayscale_900"
                        style={{ marginTop: '16px', opacity: 0.8 }}
                    >
                        <FormattedMessage
                            id="upsells.transport.modal_guidelines_additional_info"
                            defaultMessage="*Przy zakupie biletów na przejazd online."
                        />
                    </Text>
                </Box>
            </TransportModalBody>
        </Modal>
    )
}

export default TransportModal
